import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import {HoverMixin} from 'shared/helpers/mixins';
import * as Consts from '../common/Consts.js';
import {eventOnFirstTime} from 'shared/helpers/analyticsHelper';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { elementTypes } from 'crazyEditor/components/Elements/index';

const CKFINDER_HEIGHT = Consts.CONTENT_HEIGHT;
const CKFINDER_MAX_HEIGHT = Consts.MUI_DIALOG_MAX_HEIGHT_MINUS(Consts.TITLE_HEIGHT - Consts.BUTTONS_SECTION_HEIGHT);


const INITIAL_STATE = {
  selectedFileUrl: null,
};

export default class IconDialog extends Component {

  constructor(props) {
    super(props);

    this.onAddUpdate = this.onAddUpdate.bind(this);
    this.getElementProps = this.getElementProps.bind(this);

    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    this.initCkfinder();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open === false && this.props.open) {
      this.initCkfinder();
    }
  }

  onAddUpdate = () => {
    const {onAddUpdate} = this.props;
    getElementMethods(elementTypes.IconElement).getRawSvg(this.state.selectedFileUrl, (rawSVG) => {
      onAddUpdate(this.getElementProps(rawSVG));
    });
  }

  getElementProps(rawSVG) {
    return {
      data: {
        rawSVG: rawSVG,
      }
    };
  }

  setSelectedFileUrl = (event) => {
    const { files } = event.data;
    if (files.length === 1) {
      const file = event.data.files.first();
      let url = file.getUrl();
      url = url.substr(0, url.lastIndexOf('.')) + '.svg';
      this.setState({selectedFileUrl: url});
    } else {
      this.setState({selectedFileUrl: null});
    }
  };

  initCkfinder = () => {
    _.defer(() => {
      window.CKFinder.widget('icon-ckfinder-widget', {
        chooseFiles: true,
        width: '100%',
        height: '100%',
        resourceType: 'Icons',
        plugins: [],
        defaultDisplayDate: false,
        defaultDisplayFileName: false,
        defaultDisplayFileSize: false,
        startupPath: 'Icons:/Activities',
        removeModules: 'ContextMenu, CreateFolder, DeleteFolder, RenameFolder, DeleteFile, EditImage, FileDownload, FilesMoveCopy, Maximize, RenameFile, FilePreview, UploadFileButton',
        rememberLastFolder: false,
        onInit: (finder) => {
          this._finder = finder;
          window.menuReset(finder);
          finder.on('files:choose', (event) => {
            this.setSelectedFileUrl(event);
            this.onAddUpdate(this.getElementProps());
          });
          finder.on('files:selected', (event) => {
            this.setSelectedFileUrl(event);
          });
        }
      });
    });
  };

  _finder = null;

  render() {
    const {onCancel, open, newElement} = this.props;
    const {selectedFileUrl} = this.state;
    return (
      <div>
        <BaseElementDialog
          open={open}
          newElement={newElement}
          title={`${newElement ? 'Add' : 'Edit'} Icon`}
          onCancel={onCancel}
          inputValid={!_.isEmpty(selectedFileUrl)}
          onAddUpdate={this.onAddUpdate}
        >
          <div
            style={{width: Consts.DIALOG_WIDTH, height: CKFINDER_HEIGHT, maxHeight: CKFINDER_MAX_HEIGHT, overflowY: 'hidden'}}
            id="icon-ckfinder-widget"
            ref="ckfinder"
          ></div>
        </BaseElementDialog>
      </div>
    );
  }
}